const options = {
  month: 'short',
  day: 'numeric',
};

function calculateEstimateShippingWithCountry(countryCode, fulfillments, estShipping, productInfo) {
  const productTags = tfxProduct.tags;
  const productType = tfxProduct.type;
  const shippingFulfillment = productTags.find((productTag) => fulfillments[productTag]);
  let estimateShippingTime;
  if (shippingFulfillment) {
    estimateShippingTime = estimateShippingFactory('fulfillment', {
      estShipping: estShipping.fulfillment,
      productInfo: productInfo.vendor,
      currentProduct: shippingFulfillment,
    });
  } else {
    estimateShippingTime = estimateShippingFactory(
      'supplier',
      {
        estShipping: estShipping.supplier,
        productInfo: productInfo.type,
        currentProduct: productType,
      },
      countryCode
    );
  }

  return { estimateShippingTime };
}

function estimateShippingFactory(type, data, countryCode) {
  const { estShipping, productInfo, currentProduct } = data;
  let estimateTime = estShipping[productInfo[currentProduct]];
  if (estimateTime && type === 'supplier') {
    estimateTime = updateEstimateByCountry(estimateTime, countryCode);
    return estimateShippingSupplier(estimateTime);
  }

  if (estimateTime && type === 'fulfillment') {
    return estimateShippingFulfillment(estimateTime);
  }

  return false;
}

function updateEstimateByCountry(estimateTime, countryCode) {
  let cloneEstimateTime = JSON.parse(JSON.stringify(estimateTime));
  if (countryCode !== 'US') {
    cloneEstimateTime.deliveredDay.max += 3;
    cloneEstimateTime.deliveredDay.min += 3;
    cloneEstimateTime.countryCode = countryCode;
  }
  return cloneEstimateTime;
}

function estimateShippingSupplier(estimateTime) {
  const today = new Date();
  const minShipDay = addBusinessDay(estimateTime.shipDay.min);
  const maxShipDay = addBusinessDay(estimateTime.shipDay.max);
  const minDeliveredDay = addBusinessDay(estimateTime.deliveredDay.min);
  const maxDeliveredDay = addBusinessDay(estimateTime.deliveredDay.max);

  let data = {
    orderPlaced: today.toLocaleDateString('en-US', options),
    shipDay: convertShippingDate(minShipDay, maxShipDay),
    deliveredDay: convertShippingDate(minDeliveredDay, maxDeliveredDay),
    countryCode: estimateTime.countryCode,
  };
  return data;
}

function estimateShippingFulfillment(estimateTime) {
  const today = new Date();
  const minShipDay = addDay(estimateTime.shipDay.min);
  const maxShipDay = addDay(estimateTime.shipDay.max);
  const minDeliveredDay = addDay(estimateTime.deliveredDay.min);
  const maxDeliveredDay = addDay(estimateTime.deliveredDay.max);

  return {
    orderPlaced: today.toLocaleDateString('en-US', options),
    shipDay: convertShippingDate(minShipDay, maxShipDay),
    deliveredDay: convertShippingDate(minDeliveredDay, maxDeliveredDay),
  };
}

/**
 * date today + number day ship +
 * + (if day is saturday = 2, sunday = 1, others = 0)
 * + (if (today + number day ship) outside business day + 2, else + 0)
 */
function addBusinessDay(numberDay) {
  const today = new Date();
  const day = today.getDay();
  const addDay =
    today.getDate() + numberDay + (day === 6 ? 2 : +!day) + Math.floor((numberDay - 1 + (day % 6 || 1)) / 5) * 2;
  today.setDate(addDay);

  return today;
}

function addDay(numberDay) {
  const today = new Date();
  const addDay = today.getDate() + numberDay;
  today.setDate(addDay);

  return today;
}

const convertShippingDate = (minDay, maxDay) => {
  return maxDay.getMonth() !== minDay.getMonth()
    ? `${minDay.toLocaleDateString('en-US', options)} - ${maxDay.toLocaleDateString('en-US', options)}`
    : `${minDay.toLocaleDateString('en-US', options)} - ${maxDay.getDate()}`;
};
